import styled from 'styled-components';

export const ActionWrapper = styled.section`
  display: flex;
  flex-flow: row wrap;

  justify-content: center;
  padding: 0 5vw;
  font-size: clamp(14px, 1.4vw, 21px);
`;

export const ActionItem = styled.a`
  flex: 1 1;
  margin: .5em;
  cursor: pointer;
  max-width: 30rem;

  border: solid 2px ${(props) => props.theme.palette.themePrimary};
  background: ${(props) => props.theme.palette.themePrimary}00;
  transition: background-color 0.5s;

  display: flex;
  flex-direction: column;

  > .header {
    background: ${(props) => props.theme.palette.themePrimary};
    color: #fff;
    font-weight: bold;
    padding: 0.5em 0;
    text-align: center;
    position: relative;
    min-height: 4.9rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .badge {
      background: #fff;
      border-radius: 8px;
      border: solid 2px ${(props) => props.theme.palette.themePrimary};
      color: #000;
      font-size: .6em;
      font-weight: normal;
      padding: 0.3em 0.5em;
      position: absolute;
      top: -15px;
      right: -15px;
      text-transform: uppercase;
    }

    h2 {
      font-size: 1em;
      margin: 0
      padding: 0
    }

    .subtitle {
      font-size: 0.8em;
      font-style: italic;
    }
  }

  > .description {
    font-size: 0.7em;
    padding: .5em;
    text-align: left;
    font-weight: normal;
    ul {
      margin: .5em 0;
      padding: 0 0 0 1.5em;
    }
    ul {
      list-style: square;
    }
  }

  &:hover {
    background: ${(props) => props.theme.palette.themePrimary}11;
    box-shadow: 0 0 20px #777;
  }
`;



// WEBPACK FOOTER //
// ./src/app/components/ActionItem/index.jsx